/**
 * returns a truncated public_id wrapped with an anchor/link
 *
 * @param detailUrl
 * @param public_id
 * @returns {`<a href="${string}">...${string}</a>`}
 */
export const getLinkifiedPublicId = ({detailUrl, public_id}) => {
	return `<a href="${detailUrl}">...${public_id.substring(public_id.length-10, public_id.length)}</a>`
}

/**
 * returns a truncated public_id wrapped with an anchor/link
 *
 * @param detailUrl
 * @param text
 * @returns {`<a href="${string}">${string}</a>`}
 */
export const getLinkifiedText = (detailUrl, text) => {
	return `<a href="${detailUrl}">${text}</a>`
}
